export const getShimColor = (type, shimType) => (shimType ? shimType : type === 'INTERACTION' ? 'transparent' : 'opaque');
//# sourceMappingURL=utils.js.map